import { useCallback, useMemo } from 'react';
import { useSelector } from 'react-redux';
import SVGAttachment from 'visitor-ui-component-library-icons/icons/SVGAttachment';
import VizExIcon from 'visitor-ui-component-library/icon/VizExIcon';
import I18n from 'I18n';
import MenuItem from 'conversations-visitor-experience-components/visitor-widget/MenuItem';
import { useFileUpload } from 'conversations-visitor-experience-components/hooks/useFileUpload';
import { getShouldDisableAttachments } from '../../widget-ui/selectors/getShouldDisableAttachments';
// @ts-expect-error not typed
import { getSelectedThread } from '../../selected-thread/selectors/getSelectedThread';
import { selectAttachmentFile } from '../../file-uploads/actions/selectAttachmentFile';
import getAllowedFileTypes from '../../file-uploads/util/getAllowedFileTypes';
import { useAppDispatch } from '../../buildStore';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
const AttachFileItem = ({
  onClose,
  disabled = false
}) => {
  const dispatch = useAppDispatch();
  const shouldDisableAttachments = useSelector(getShouldDisableAttachments);
  const selectedThread = useSelector(getSelectedThread);
  const fileAccept = useMemo(() => getAllowedFileTypes(), []);
  const onAttachFile = useCallback(files => {
    if (!(files !== null && files !== void 0 && files.length) || !selectedThread) return;
    const file = files[0];
    if (file) {
      dispatch(selectAttachmentFile({
        file,
        thread: selectedThread,
        source: 'file_upload'
      }));
    }
  }, [dispatch, selectedThread]);
  const {
    handleAttachFileClick,
    renderFileInput
  } = useFileUpload({
    onAttachFile,
    fileAccept
  });
  const handleClick = useCallback(() => {
    onClose();
    handleAttachFileClick();
  }, [onClose, handleAttachFileClick]);
  if (shouldDisableAttachments) return null;
  const disabledTitle = disabled ? I18n.text('conversations-visitor-experience-components.attachmentDisabledTooltip') : undefined;
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsxs(MenuItem, {
      role: "menuitem",
      "data-test-id": "spotlight-attach-file",
      $disabled: disabled,
      disabled: disabled,
      "aria-disabled": disabled,
      title: disabledTitle,
      onClick: disabled ? undefined : handleClick,
      children: [/*#__PURE__*/_jsx(VizExIcon, {
        icon: /*#__PURE__*/_jsx(SVGAttachment, {}),
        size: "16px"
      }), I18n.text('conversations-visitor-experience-components.attachFile')]
    }), renderFileInput()]
  });
};
AttachFileItem.displayName = 'AttachFileItem';
export default AttachFileItem;